<ek-dialog-header>
  <div class="dialog-header">
    <span>{{ 'INSEGNAMENTO.CHANGE_MODAL.HEADER' | translate }}</span>
  </div>
</ek-dialog-header>

<ek-dialog-body>
  <div class="card p-4">
    <ek-table dataKey="id" [mode]="'editable'" [dataSource]="insegnamentiDataSource" [radioBtnRowSelection]="true" [(selection)]="selectedTableInsegnamento"
                        [showHeader]="false" [emptyState]="EMPTY_STATE" [rowsToShow]="5" (onRowSelect)="onSelectionChange($event)" (onBtnClick)="onRowBtnClick($event)" >
                </ek-table>
    </div>
</ek-dialog-body>

<ek-dialog-footer class="dialog-footer">
  @if (canManageSubtenants) {
    <ek-button left
               (click)="openCreateModal()"
               [severity]="'primary'"
               [disabled]="isLoading || isDialogLoading"
               [label]="'INSEGNAMENTO.CHANGE_MODAL.CREA' | translate"></ek-button>
  }

  <ek-button (click)="close()"
             [label]="'INSEGNAMENTO.CHANGE_MODAL.ANNULLA' | translate"
             style="margin-right: 10px;"></ek-button>

  <ek-button (click)="confirmSelection()" [disabled]="isConfirmDisabled()" [loading]="isDialogLoading"
             [label]="'INSEGNAMENTO.CHANGE_MODAL.CAMBIA' | translate"></ek-button>
</ek-dialog-footer>